import { api } from "../../utils/apiClient";

/**
 * Ask for the audit report of a site that couldn't be crawled to be emailed later.
 *
 * The backend queues the site for background retries and notifies the team.
 *
 * @param url - The website whose audit failed
 * @param email - Where to send the report once an audit succeeds
 */
export async function requestPendingAuditReport(url: string, email: string): Promise<void> {
  await api.post("/audit/pending", { url, email });
}
